import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteConfirmDialogComponent } from '../../delete-confirm-dialog/delete-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-category-node',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manage-category-node.component.html',
  styleUrl: './manage-category-node.component.css',
  animations: [
    trigger('fadeAnimation', [
      state('deleted', style({
        opacity: 0.5,
        backgroundColor: '#f0f0f0',
      })),
      state('active', style({
        opacity: 1,
        backgroundColor: 'white',
      })),
      transition('active <=> deleted', [
        animate('400ms ease-in-out')
      ]),
    ])
  ]
})
export class CategoryNodeComponent {
  @Input() children: any[] = [];
  @Input() parentIdForNewCategory: number | null = null;

  @Output() addSub = new EventEmitter<number>();

  @Output() deleteCategoryEvent = new EventEmitter<number>();
  @Output() restoreCategoryEvent = new EventEmitter<any>();

  expandedNodes: Set<number> = new Set();

  constructor(private dialog: MatDialog) { }

  toggleSubcategories(categoryId: number): void {
    if (this.expandedNodes.has(categoryId)) {
      this.expandedNodes.delete(categoryId);
    } else {
      this.expandedNodes.add(categoryId);
    }
  }

  hasChildren(category: any): boolean {
    return Array.isArray(category.children) && category.children.length > 0;
  }


  emitAddSubcategory(categoryId: number): void {
    this.addSub.emit(categoryId);
  }

  confirmDeleteCategory(category: any): void {
    const hasChildren = category.children && category.children.length > 0;

    let message = '';

    if (hasChildren) {
      message = `This category has subcategories. Deleting it will delete ALL subcategories too. Are you sure you want to continue?`;
    } else {
      message = `Are you sure you want to delete this category?`;
    }

    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { message, buttonValue: 'Delete' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteCategory(category.category_id);
      }
    });
  }

  confirmRestoreCategory(category: any): void {
    const message = `Are you sure you want to restore this category?`;

    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { message, buttonValue: 'Restore' }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.emitRestoreCategory(category);
      }
    });
  }



  deleteCategory(categoryId: number): void {
    this.deleteCategoryEvent.emit(categoryId);
  }


  emitRestoreCategory(category: any): void {
    this.restoreCategoryEvent.emit(category);
  }


}
